import moment from 'moment';
import { Document, Model3d, Scene3d } from '../../models/models';
import { ArSmartflowTheme } from '../../theme/ar-smartflow-theme';

export const getNodeTypeLabel = (nodeType: string) => {
    switch (nodeType) {
        case 'phase':
            return 'Fase';
        case 'subphase':
            return 'Sottofase';
        case 'task':
            return 'Task';
    }
};

export const getRefusedAttachmentsLabel = (refusedAttachmentsCount: number) => {
    return refusedAttachmentsCount === 0
        ? 'Nessun allegato rifiutato'
        : refusedAttachmentsCount === 1
            ? '1 allegato rifiutato'
            : `${refusedAttachmentsCount} allegati rifiutati`;
};

export const getDocumentStatusDate = (document: Document) => {
    let dateString = '';
    switch (document.status.key) {
        case 'active':
            dateString = document.created_at;
            break;
        case 'rejected':
            dateString = document.rejected_at;
            break;
        case 'approved':
            dateString = document.approved_at;
            break;
        case 'replaced':
            dateString = document.replaced_at;
            break;
        default:
            return '';
    }

    if (!dateString || !moment(dateString, moment.ISO_8601, true).isValid()) {
        return '';
    }

    return moment(dateString).format('DD/MM/YYYY');
};

export const getDocumentStatusUser = (document: Document) => {
    let userString = '';

    switch (document.status.key) {
        case 'active':
            userString = document.created_by;
            break;
        case 'rejected':
            userString = document.rejected_by;
            break;
        case 'approved':
            userString = document.approved_by;
            break;
        case 'replaced':
            userString = document.replaced_by;
            break;
        default:
            return '';
    }
    return userString;
};

interface StatusObject {
    status: {
        key: string;
    };
}

export const getStatusLabel = (item: StatusObject) => {
    let color: string = '';

    switch (item.status.key) {
        case 'rejected':
            color = ArSmartflowTheme.palette.error.main;
            break;
        case 'approved':
            color = ArSmartflowTheme.palette.success.main;
            break;
        case 'replaced':
            color = ArSmartflowTheme.palette.warning.main;
            break;
        default:
            return '';
    }

    return color;
};

export const getModel3dStatusDate = (model3d: Model3d) => {
    let dateString = '';
    switch (model3d.status.key) {
        case 'active':
            dateString = model3d.created_at;
            break;
        case 'rejected':
            dateString = model3d.rejected_at;
            break;
        case 'approved':
            dateString = model3d.approved_at;
            break;
        case 'replaced':
            dateString = model3d.replaced_at;
            break;
        default:
            return '';
    }
    if (!dateString || !moment(dateString, moment.ISO_8601, true).isValid()) {
        return '';
    }
    return moment(dateString).format('DD/MM/YYYY');
};

export const getModel3dStatusUser = (model3d: Model3d) => {
    let userString = '';

    switch (model3d.status.key) {
        case 'active':
            userString = model3d.created_by;
            break;
        case 'rejected':
            userString = model3d.rejected_by;
            break;
        case 'approved':
            userString = model3d.approved_by;
            break;
        case 'replaced':
            userString = model3d.replaced_by;
            break;
        default:
            return '';
    }
    return userString;
};

export const getUserScene = (scene: Scene3d) => {
    const userString = scene.created_by;
    return userString;
};

export const getDateScene = (scene: Scene3d) => {
    const dateString = scene.created_at;
    if (!dateString || !moment(dateString, moment.ISO_8601, true).isValid()) {
        return '';
    }
    return moment(dateString).format('DD/MM/YYYY');
};
